<template>
  <div class="alertcontent" v-if="dialogVisible">
    <div class="alertcontentdiv">
      <div class="alertcontentdiv_head">
        <p>{{dlgTitle}}</p>
        <div>
          <i class="el-icon-close" @click="cancel"></i>
        </div>
      </div>
      <div class="alertcontentdiv_params">
        <div class="content-params">
          <!-- 角色名称 -->
          <div class="params">
            <label class="custom_label">角色名称：</label>
            <span style="min-width:210px"><el-input placeholder="请输入角色名称" v-model="raoleName"></el-input></span>
          </div>
          <span class="orgBtn btn-font" @click="searchData()"><i class="iconfont icon-chaxun"></i><label>搜索</label></span>
        </div>
      </div>
      <div class="alertcontentdiv_table">
        	<el-table ref="multipleTable" :data="dataList" class="checkTabel"
            :highlight-current-row="true" @select-all="selectAll" @select="userSelect"
            @row-click="rowClick" tooltip-effect="dark" style="width: 100%"  border height=100%>
            <!--<div  slot="empty" v-if="emptyErrorText" :class="loading?'':'empty-err'">{{loading?'暂无数据':emptyErrorText}}</div>-->
              <el-table-column center align="center" type="selection" width="55"></el-table-column>
            <el-table-column center align="center" type="index" width="55" :label="'序号'"></el-table-column>

            <el-table-column v-for="(item,index) in tableColumns" :key="index" :prop="item.name" align="center" :label="item.label" show-overflow-tooltip center>
                  <template slot-scope="scope">{{item.formatter ? item.formatter(scope.row[item.name], scope.row, index) : scope.row[item.name]}}</template>
              </el-table-column>
           </el-table>
      </div>
      <div class="alertcontentdiv_buttom">
        <el-button @click="cancel">取消</el-button>
        <el-button type="primary" @click="confirm">确认</el-button>
      </div>
    </div>
  </div>
</template>
<script>
// import * as Api from '@/api/promotion.js'
import { methodPost, methodGet } from '../../../api/request'
function requried(column) {
  throw new Error(`缺少参数[${column}]`)
}
import MCTB from '@/utils/MultipleCheckTableBack.js'

export default {
  name: 'SearchDialog',
  props: {
    modalTitle: String,
    data: Array,
    dialogVisible: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  data() {
    return {
      show: false,
      loading: false,
      multipleSelection: [],
      requestCheckedRoles: false,
      raoleName: '',
      MCTB: null,
      dlgTitle: '',
      selectedItem: {},
      tableColumns: [],
      dataList: [ // 数据源
      ]
    }
  },
  created() {
  },
  methods: {
    async open({
      dlgTitle,
      url = requried('url'),
      selectId,
      selectedItem,
      tableColumns = requried('tableColumns'),
      emptyMessage = requried('emptyMessage'),
      idField = 'id',
      filialeSelect = {}
    }) {
      this.organizeCode = '';
      this.requestCheckedRoles = false
      this.organizeName = '';
      this.show = true;
      this.dlgTitle = dlgTitle;
      this.url = url;
      this.selectId = selectId || [];
      this.idField = idField
      this.selectedItem = selectedItem
      this.tableColumns = tableColumns;
      this.emptyMessage = emptyMessage;
      this.MCTB = new MCTB({
        vueComponent: this,
        tableName: 'multipleTable', // 需要操作的table名字
        multipleSelection: this.multipleSelection, // 已选中的需要回显的初始值
        defaultKey: 'id', // 需要判断的id和回显的名称
        defaultName: 'roleName',
        tableData: this.dataList // 表格的数据
      })
      // this.checkData(this.id);
      return new Promise((resolve, reject) => {
        this.getData().then(() => {
          this.selectedItem = this.dataList.find(o => o[this.idField] === this.selectId) || {};
          if (!this.requestCheckedRoles) {
            this.getUserRoles()
          }
          this.resolve = resolve;
          this.reject = reject;
        })
      })
    },
    // 用户点击操作时记录
    userSelect(selection, row) {
      this.MCTB.userSelectChange(selection, row)
    },
    // 全选
    selectAll(selection) {
      this.MCTB.userSelectAll(selection, this.dataList)
    },
    getData(params) {
      this.loading = true
      return methodPost(this.url, {
        ...params
      }).then(res => {
        this.loading = false
        const { code, data, message } = res
        if (code !== 0) {
          this.$message(message)
        } else {
          this.dataList = data
        }
      })
    },
    getUserRoles() {
      methodGet('/user/getRoleById/' + this.selectId).then(res => {
        this.loading = false
        this.requestCheckedRoles = true
        const { code, data, message } = res
        if (code !== 0) {
          this.$message(message)
        } else {
          this.multipleSelection = data
          this.MCTB.setBackShow(this.dataList, this.multipleSelection)
        }
      })
    },
    rowClick(row, column, cell, event) {
      this.selectId = row[this.idField];
      this.selectedItem = row;
    },
    confirm() {
      const selection = this.MCTB.getMultipleKeys()

      if (selection.length < 1) {
        this.$message.error(this.emptyMessage)
      } else {
        methodPost("/user/assignRoles", { id: this.selectId, roleIdList: selection }).then(res => {
          if (res.code === 0) {
            this.resolve()
          } else {
            this.$message.error(res.message)
          }
        }).catch(res => {
          console.log(res)
        })
      }
    },
    searchData() {
      const params = {
        roleName: this.raoleName
      }
      this.getData(params)
    },
    cancel() {
      this.$emit("cancel");
      this.raoleName = ''
    }
  }
}
</script>

<style type="text/scss" lang="scss" scoped>
  .empty-err{
    text-align: center;
    color: red
  }
.alertcontent {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index:9;
  .alertcontentdiv {
    position: absolute;
    left: calc(50% + 90px);
    top: 50%;
    transform: translate(-50%, -50%);
    width: 900px;
    height: 660px;
    padding: 20px;
    // padding-top: 0;
    background: #fff;
    display: flex;
    flex-direction: column;
    .el-icon-close {
      font-size: 20px;
      cursor: pointer;
    }
    .alertcontentdiv_head {
      display: flex;
      align-items: center;
      position: relative;
      padding-bottom: 10px;
      border-bottom: 1px solid #ddd;
      p {
        height: 30px;
        line-height: 30px;
        font-size: 18px;
        font-weight: bold;
      }
      &>div {
        position: absolute;
        right: 10px;
      }
    }
    .alertcontentdiv_table {
      flex:1;
      overflow-y: auto;
      .checkTabel{
        flex:1;
        overflow-y: auto;
      }
    }
    .alertcontentdiv_page {
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 10px;
      div:nth-of-type(1) {
        font-size: 14px;
      }
      .el-pagination {
        float: right;
      }
    }
    .alertcontentdiv_buttom {
      height: 32px;
      display: flex;
      justify-content: flex-end;
      margin-top:20px;
    }
  }
  .content-params {
      padding:5px 20px;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      overflow: hidden;
      .params {
        min-width:340px;
        margin: 5px 0;
        font-size: 0;
      }
      .custom_label {
        min-width: 80px;
        display:inline-block;
        font-size: 14px;
        font-weight:700;
        text-align: right;
        color:#606266;
        i {
          color: red;
          font-style: normal;
          vertical-align: middle;
        }
      }
    }
}
</style>



// WEBPACK FOOTER //
// src/_app/wwka/src/views/userManagementList/customTable/check-dialog.vue